import React from 'react';
// import Logo from '../../img/icon_videoLogger.svg';

import {connect} from 'react-redux';
import {showUserFlag} from '../../actions';
import {UserDetail} from '../../components/modal';

// TODO: 사용자 정보
const UserInfo = ({handleLogoutClose, userFlag, showUserFlag}) => {
  const propertys = {
    className: 'logout',
    onClick: handleLogoutClose
  }
  
  const handleUserShow = () => {
    showUserFlag(true, 'user');
  }

  const handleUserHide = () => {
    showUserFlag(false);
  }

  const userName = sessionStorage.getItem('name') && sessionStorage.getItem('name');
  return (
    <div className="user-info">
      <div className="user" onClick={handleUserShow}>{userName}</div>
      <div {...propertys}></div>
      {userFlag && <UserDetail 
                    userInfoType="user"
                    handleUserHide={handleUserHide} />}
    </div>
  );
};
const mapStateToProps = state => {
  return {
    userFlag: state.userFlag
  }
}

const mapDispatcherToProps = dispatch => {
  return {
      showUserFlag: (userFlag, userInfoType) => dispatch(showUserFlag(userFlag, userInfoType))
      
  }
};
export default connect(mapStateToProps, mapDispatcherToProps)(UserInfo);


// WEBPACK FOOTER //
// ./src/components/userInfo/index.js